import { Action, createReducer, on } from '@ngrx/store';
import { initialMPFlightTransactionServiceState } from './mp-flight-transaction-service.state';
import {
  getCertificateTransactionInfo,
  getCertificateTransactionInfoFailure,
  getCertificateTransactionInfoSuccess,
} from './mp-flight-transaction-service.actions';
import { Status } from '../../../models/status';

const featureReducer = createReducer(
  initialMPFlightTransactionServiceState,
  on(getCertificateTransactionInfo, (state) => ({
    ...state,
    getCertificateCrudStatus: Status.LOADING,
  })),

  on(getCertificateTransactionInfoSuccess, (state, { response }) => ({
    ...state,
    certificateTransactionInfo: response.response,
    certificateTransactionInfoStatus: response.status,
    getCertificateCrudStatus: Status.STABLE,
  })),

  on(getCertificateTransactionInfoFailure, (state, { response }) => ({
    ...state,
    certificateTransactionInfo: response.response,
    certificateTransactionInfoStatus: response.status,
    certificateTransactionInfoExceptionContent: response.exceptionContent,
    getCertificateCrudStatus: Status.FAILED,
  }))
);

export function mpFlightTransactionServiceReducer(state = initialMPFlightTransactionServiceState, action: Action) {
  return featureReducer(state, action);
}
